import {
	Component,
	OnInit,
	OnChanges,
	Input,
	Output,
	ElementRef,
	EventEmitter,
	ViewChild,
	SimpleChanges,
} from "@angular/core";

@Component({
	selector: "app-quiz",
	templateUrl: "./quiz.directive.html",
	styleUrls: ["./quiz.directive.css"],
})
export class QuizDirective implements OnChanges {
	@Input() questionFontsize?: string;
	@Input() questionFontColor?: String;
	@Input() optionFontsize?: string;
	@Input() optionFontColor?: String;
	@Input() quizQuestion?: string;
	@Input() quizOptions: Array<any>;
	@Input() quizType: string; //multiple or single
	@Input() buttonlabel: string;
	@Input() showResult?: Boolean;
	@Input() textDirection: string;
	@Output() quizResult: EventEmitter<any> = new EventEmitter<any>();
	@Output() quizHeight: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild("questionCon", { static: true }) questionCon: ElementRef;
	@ViewChild("mcqCon", { static: true }) mcqCon: ElementRef;
	@ViewChild("submitbtnCon", { static: true }) submitCon: ElementRef;

	@Input() btnDisabled?: Boolean = true;

	public attempts: number = 0;
	public bshowQuiz: Boolean = false;
	constructor(private elRef: ElementRef) {}

	ngOnInit() {}
	ngOnChanges(changes: SimpleChanges) {
		if (changes.hasOwnProperty("btnDisabled") && !changes.btnDisabled.currentValue) {
			this.btnDisabled = true;
		}
	}

	ngAfterViewInit() {
		this.quizHeight.emit({
			height:
				this.questionCon.nativeElement.scrollHeight +
				this.mcqCon.nativeElement.scrollHeight +
				this.submitCon.nativeElement.scrollHeight,
		});
	}

	public choiceSelectedHandler(event) {
		console.log("QuizDirective   :", event);
		this.btnDisabled = event.status == "selected" ? false : true;
	}
	public submitButtonClickhandler() {
		this.attempts++;
		let bCorrect: Boolean = true;
		let selectedOptions = [];
		for (let item of this.quizOptions) {
			if (item.correct !== item.selected) {
				bCorrect = false;
				break;
			}
		}
		for (let item of this.quizOptions) {
			if (item.selected) {
				selectedOptions.push(item.text);
			}
		}
		if (bCorrect) {
			this.bshowQuiz = true;
			this.quizResult.emit({
				result: "correct",
				selectedOptions: selectedOptions,
			});
		} else {
			this.quizResult.emit({
				result: "incorrect",
				selectedOptions: selectedOptions,
			});
		}
		if (this.showResult) {
			this.bshowQuiz = false;
			for (let item of this.quizOptions) {
				if (item.correct && item.selected) {
					item.showResult = true;
					item.backgroundColor = item.correctBackgroundColor;
					item.fontColor = "#000000";
				} else if (!item.correct && item.selected) {
					item.showResult = true;
					item.backgroundColor = "";
				} else if (item.correct) {
					item.backgroundColor = item.inCorrectBackgroundColor;
					item.fontColor = "#000000";
				}
				item.disabled = true;
			}
		}
	}
}
